import { render, staticRenderFns } from "./codemirror.component.vue?vue&type=template&id=5d3d87c5&scoped=true&"
import script from "./codemirror.component.vue?vue&type=script&lang=js&"
export * from "./codemirror.component.vue?vue&type=script&lang=js&"
import style0 from "./codemirror.component.vue?vue&type=style&index=0&id=5d3d87c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3d87c5",
  null
  
)

export default component.exports